var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TelephoneFill",
    clipPath: "url(#clip0_862_6555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82821 1.26672C3.09067 1.00465 3.40583 0.801358 3.7528 0.670305C4.09977 0.539253 4.47064 0.483436 4.84082 0.506555C5.21099 0.529673 5.57203 0.631198 5.9 0.804402C6.22797 0.977607 6.51539 1.21853 6.74321 1.51122L9.43571 4.97022C9.92921 5.60472 10.1032 6.43122 9.90821 7.21122L9.08771 10.4962C9.04529 10.6664 9.04758 10.8446 9.09436 11.0136C9.14114 11.1826 9.23083 11.3366 9.35471 11.4607L13.0402 15.1462C13.1645 15.2704 13.3187 15.3602 13.488 15.407C13.6573 15.4538 13.8358 15.4559 14.0062 15.4132L17.2897 14.5927C17.6746 14.4965 18.0764 14.489 18.4646 14.5709C18.8529 14.6527 19.2174 14.8218 19.5307 15.0652L22.9897 17.7562C24.2332 18.7237 24.3472 20.5612 23.2342 21.6727L21.6832 23.2237C20.5732 24.3337 18.9142 24.8212 17.3677 24.2767C13.4095 22.884 9.81561 20.618 6.85271 17.6467C3.88164 14.6842 1.61562 11.0909 0.222706 7.13322C-0.320294 5.58822 0.167206 3.92772 1.27721 2.81772L2.82821 1.26672Z",
    fill: "url(#paint0_linear_862_6555)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_6555",
    x1: 12.0004,
    y1: 0.501465,
    x2: 12.0004,
    y2: 24.5004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_6555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.88fdcdeb8255f52ce5fe9d532f5c9792.svg";
export { ForwardRef as ReactComponent };